<div class="container-fluid p-3">
    <!-- Header Section -->
    <div class="page-header mb-4">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <h4 class="mb-1">
                    Upload Challenge Details
                </h4>
                <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
                <div class="status-badge">
                    <span class="badge" [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }">
                        {{
                        stepDetails?.step_status == 0
                        ? "INITIATION PENDING"
                        : (stepDetails?.step_status | uppercase)
                        }}
                    </span>
                </div>
            </div>

            <div class="action-buttons">
                <button class="btn btn-outline-secondary me-2" (click)="generatePDF()">
                    <i class="pi pi-file-pdf me-1"></i> PDF
                </button>

                <ng-container *ngIf="stepDetails?.step_status == 'approved'">
                    <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
                        Next <i class="pi pi-angle-right ms-1"></i>
                    </button>
                </ng-container>

                <ng-container *ngIf="
            stepDetails?.is_initiator ||
            stepDetails?.is_approver ||
            stepDetails?.is_recommender ||
            (stepDetails?.step_status != 'approved' && userID == 6)
          ">
                    <button class="btn btn-primary me-2" (click)="onSubmit()" [disabled]="
              challengeForm?.invalid
            ">
                        <i class="pi pi-save me-1"></i> Save
                    </button>
                </ng-container>

                <ng-container *ngIf="stepDetails?.is_initiator">
                    <button class="btn btn-success" (click)="IRA.emit('Initiate')">
                        <i class="pi pi-play me-1"></i> Initiate
                    </button>
                </ng-container>

                <ng-container *ngIf="stepDetails?.is_approver">
                    <button class="btn btn-success" (click)="IRA.emit('Approve')">
                        <i class="pi pi-check-circle me-1"></i> Approve
                    </button>
                </ng-container>

                <ng-container *ngIf="stepDetails?.is_recommender">
                    <button class="btn btn-info" (click)="IRA.emit('Recommend')">
                        <i class="pi pi-thumbs-up me-1"></i> Recommend
                    </button>
                </ng-container>
            </div>
        </div>
    </div>

    <hr class="my-3" />

    <!-- Challenge Form Section (idex-from component) -->
    <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md"
        *ngIf="stepDetails">
        <div (click)="toggleChallengeForm()"
            class="flex items-center justify-between p-4 cursor-pointer bg-gray-200 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
            <h3 class="text-lg font-semibold flex items-center">
                <span class="w-8 h-8 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-sm">
                    <i class="pi pi-file-edit"></i>
                </span> Challenge Form <span
                    class="w-12 p-1 border-2 border-purple-500 ml-5 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-sm">
                    View </span>
            </h3>
            <i class="pi transition-transform duration-200"
                [ngClass]="isChallengeFormOpen ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
        </div>
        <div *ngIf="isChallengeFormOpen" class="p-6 space-y-4 border-t border-slate-100 animate-fade-in">
            <app-idex-from [stepDetails]="stepDetails" [challengesData]="needGenData" [url]="getChallengeUrl()"></app-idex-from>
        </div>
    </div>

    <!-- Main Form Content -->
    <div class="form-wrapper">
        <ng-container>
            <form [formGroup]="challengeForm" (ngSubmit)="onSubmit()">
                <!-- Section A: Nodal Agency Details -->
                <div class="card mb-4">
                    <div class="card-header bg-light">
                        <h5>A. Nodal Agency Details</h5>
                    </div>
                    <div class="card-body">
                        <div class="row g-3">
                            <div class="col-md-6">
                                <label class="form-label">Organisation<span class="text-danger">*</span></label>
                                <input type="text" class="form-control" formControlName="organisation"
                                    maxlength="100" />
                            </div>
                            <div class="col-md-6">
                                <label class="form-label">Category</label>
                                <p-dropdown [options]="categoryOptions" formControlName="category" optionLabel="label"
                                    optionValue="value" placeholder="-- Select Category --" class="w-100">
                                </p-dropdown>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label">Release Date<span class="text-danger">*</span></label>
                                <input type="date" class="form-control" formControlName="releaseDate" />
                            </div>
                            <div class="col-md-6">
                                <label class="form-label">Approved By (APSO)</label>
                                <input type="text" class="form-control" formControlName="approvedBy" maxlength="100" />
                            </div>
                            <!-- <div class="col-md-6">
                                <label class="form-label">Coordinating Agency<span class="text-danger">*</span></label>
                                <input type="text" class="form-control" formControlName="coordinatingAgency"
                                    maxlength="100" />
                            </div> -->
                             <div class="col-md-6">
                <label class="form-label">Coordinating Agency<span class="text-danger">*</span></label>
                <p-dropdown [options]="unitList" formControlName="coordinatingAgency" optionValue="id" optionLabel="name"
                  placeholder="Select a Directorate" class="w-100" (onChange)="onUnitChange($event)" [filter]="true" filterBy="name"
                  appendTo="body">
                </p-dropdown>
              </div>
              <div class="col-md-6 mb-3">
                <label>Nodal Officer</label>
                <p-dropdown [options]="userList" formControlName="nodalOfficer" optionValue="id" optionLabel="first_name"
                  placeholder="Select a User" class="w-100" (onChange)="onUserChange($event)" [filter]="true" filterBy="first_name"
                  appendTo="body">
                </p-dropdown>
              </div>
                            <div class="col-md-6">
                                <label class="form-label">Technology Domain<span class="text-danger">*</span></label>
                                <input type="text" class="form-control" formControlName="technologyDomain"
                                    maxlength="100" />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Section B: Problem Statement -->
                <div class="card mb-4">
                    <div class="card-header bg-light">
                        <h5>B. Problem Statement for iDEX Challenge</h5>
                    </div>
                    <div class="card-body">
                        <div class="mb-4">
                            <label class="form-label">CHALLENGE TITLE<span class="text-danger">*</span></label>
                            <input type="text" class="form-control" formControlName="challengeTitle" maxlength="150" />
                        </div>

                        <!-- <div class="mb-4">
                            <label class="form-label">Nodal Officer<span class="text-danger">*</span></label>
                            <p-dropdown [options]="userList" formControlName="nodalOfficer" optionValue="id"
                                optionLabel="first_name" placeholder="Select a User" class="w-100" [filter]="true"
                                filterBy="first_name" appendTo="body">
                                <ng-template let-user pTemplate="item">
                                    <div class="list-group-item list-group-item-action">
                                        {{user.unit.name}} - {{ user.hrcdf_designation }} {{ user.first_name }} {{
                                        user.last_name }} -
                                        <small>{{ user.loginname }}</small>
                                    </div>
                                </ng-template>
                            </p-dropdown>
                        </div> -->

                        <!-- ✅ New Field: Name of Firm -->
                        <div class="mb-4">
                            <label class="form-label">Name of Firm<span class="text-danger">*</span></label>
                            <input type="text" class="form-control" formControlName="firmName" maxlength="150" />
                        </div>

                        <!-- ✅ New Field: Recommendation of PI -->
                        <div class="mb-4">
                            <label class="form-label">Recommendation of PI<span class="text-danger">*</span></label>
                            <textarea rows="3" class="form-control" formControlName="recommendationPI"
                                maxlength="500"></textarea>
                        </div>

                        <div class="mb-4">
                            <label class="form-label">Problem Statement<span class="text-danger">*</span></label>
                            <input type="text" class="form-control" formControlName="problemStatement"
                                maxlength="150" />
                        </div>
                        <div class="rich-text-section" [class.readonly-editor]="isEditorDisabled">
                            <label class="form-label">• Challenge Brief/ Definition<span
                                    class="text-danger">*</span></label>
                            <editor [init]="init" formControlName="challengeBrief" [disabled]="isEditorDisabled">
                            </editor>
                        </div>

                        <div class="rich-text-section" [class.readonly-editor]="isEditorDisabled">
                            <label class="form-label">• Future Expectation from the prototype development<span
                                    class="text-danger">*</span></label>
                            <editor [init]="init" formControlName="prototypeDevelopment" [disabled]="isEditorDisabled">
                            </editor>
                        </div>

                        <!-- Additional sections in accordion for better organization -->
                        <div class="accordion mb-3" id="challengeDetailsAccordion">
                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#additionalDetails">
                                        Additional Challenge Details
                                    </button>
                                </h2>
                                <div id="additionalDetails" class="accordion-collapse collapse">
                                    <div class="accordion-body">
                                        <div class="rich-text-section" [class.readonly-editor]="isEditorDisabled">
                                            <label class="form-label">• Need/Requirement of the proposed challenge<span
                                                    class="text-danger">*</span></label>
                                            <editor [init]="init" formControlName="requirement"
                                                [disabled]="isEditorDisabled">
                                            </editor>
                                        </div>

                                        <!-- <div class="rich-text-section" [class.readonly-editor]="isEditorDisabled">
                                            <label class="form-label">• IP Value</label>
                                            <editor [init]="init" formControlName="ipValue"
                                                [disabled]="isEditorDisabled"></editor>
                                        </div> -->

                                        <!-- Include all other rich text sections here -->
                                        <div class="rich-text-section" [class.readonly-editor]="isEditorDisabled">
                                            <label class="form-label" for="functionalAdvantages">• Functional
                                                Advantages<span class="text-danger">*</span></label>
                                            <editor [init]="init" formControlName="functionalAdvantages"
                                                [disabled]="isEditorDisabled">
                                            </editor>
                                        </div>
                                        <div class="rich-text-section" [class.readonly-editor]="isEditorDisabled">
                                            <label class="form-label" for="domestic">• Domestic Capability
                                                Development<span class="text-danger">*</span></label>
                                            <editor [init]="init" formControlName="domestic"
                                                [disabled]="isEditorDisabled"></editor>
                                        </div>
                                        <div class="rich-text-section" [class.readonly-editor]="isEditorDisabled">
                                            <label class="form-label" for="substitution">• Import Substitution
                                                (Reliability and Flexibility of
                                                existing source of import)<span class="text-danger">*</span></label>
                                            <editor [init]="init" formControlName="substitution"
                                                [disabled]="isEditorDisabled"></editor>
                                        </div>
                                        <!-- <div class="rich-text-section"> -->
                                        <div class="rich-text-section" [class.readonly-editor]="isEditorDisabled">
                                            <label class="form-label" for="preliminaryScope">• Preliminary scope of
                                                solution being
                                                developed<span class="text-danger">*</span></label>
                                            <editor [init]="init" formControlName="preliminaryScope"
                                                [disabled]="isEditorDisabled"></editor>
                                        </div>
                                        <div class="rich-text-section" [class.readonly-editor]="isEditorDisabled">
                                            <label class="form-label" for="competitiveSolution">• Global competitive
                                                nature of the problem
                                                including
                                                novelty of the solution (from user prospective)<span
                                                    class="text-danger">*</span></label>
                                            <editor [init]="init" formControlName="competitiveSolution"
                                                [disabled]="isEditorDisabled">
                                            </editor>
                                        </div>
                                        <div class="rich-text-section" [class.readonly-editor]="isEditorDisabled">
                                            <label class="form-label" for="potentialMarket">• Potential Market for
                                                product/technology (from
                                                user
                                                perspective)<span class="text-danger">*</span></label>
                                            <editor [init]="init" formControlName="potentialMarket"
                                                [disabled]="isEditorDisabled"></editor>
                                        </div>
                                        <div class="form-label" class="rich-text-section"
                                            [class.readonly-editor]="isEditorDisabled">
                                            <label for="riskAssessment">• Risk Assessment<span
                                                    class="text-danger">*</span></label>
                                            <editor [init]="init" formControlName="riskAssessment"
                                                [disabled]="isEditorDisabled"></editor>
                                        </div>
                                        <div class="rich-text-section" [class.readonly-editor]="isEditorDisabled">
                                            <label class="form-label" for="mpoQty">• Pilot Procurement Plan with Minimum
                                                Pilot Order
                                                Quality(MPQ)<span class="text-danger">*</span></label>
                                            <editor [init]="init" formControlName="mpoQty"
                                                [disabled]="isEditorDisabled"></editor>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <ng-container *ngIf="needGenData?.pds">
                        <h3 class="mt-4">Uploaded PDS Document</h3>
                        <ul>
                            <li><a href="{{ apiUrl + needGenData?.pds}}" target="_blank"
                                    rel="noopener noreferrer">{{getFileName(needGenData?.pds)}}</a></li>
                        </ul>
                    </ng-container>

                    <!-- Draft SOTR Upload (Single file) -->
                    <label for="draftSotr" *ngIf="
              stepDetails?.is_initiator ||
              stepDetails?.is_approver ||
              stepDetails?.is_recommender ||
              (stepDetails?.step_status != 'approved' && userID == 6)
            ">Upload PDS Document</label>
                    <!-- <p-fileUpload name="draftSotr" #draftSotrUpload [auto]="true" [customUpload]="true"
                        [multiple]="false" mode="advanced" [maxFileSize]="209715200"
                        accept=".pdf,.doc,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        (uploadHandler)="onUploadDraftSotr($event)" *ngIf="
              stepDetails?.is_initiator ||
              stepDetails?.is_approver ||
              stepDetails?.is_recommender ||
              (stepDetails?.step_status != 'approved' && userID == 6)
            ">
                        <ng-template #empty>
                            <div>Drag and drop the document here to upload.</div>
                        </ng-template>
                    </p-fileUpload> -->
                    <!-- Document Upload Table -->
            <app-upload-document (uploadData)="onDocumentUpload($event)" [dmsFiles]="allDmsFiles" (documentEdited)="onDocumentEdited($event)"
                (documentDeleted)="onDocumentDeleted($event)">
            </app-upload-document>
<!-- Supporting Documents Upload (Multiple files) -->
                    <!-- <ng-container *ngIf="needGenData?.pru">
                        <h3 class="mt-4">Uploaded PRU Document</h3>
                        <ul>
                            <li><a href="{{ apiUrl + needGenData.pru}}" target="_blank"
                                    rel="noopener noreferrer">{{getFileName(needGenData.pru)}}</a></li>
                        </ul>
                    </ng-container>

                    
                    <label for="supportingDocs" class="mt-2" *ngIf="
              stepDetails?.is_initiator ||
              stepDetails?.is_approver ||
              stepDetails?.is_recommender ||
              (stepDetails?.step_status != 'approved' && userID == 6)
            ">Upload PRU Document</label>
                    <p-fileUpload name="supportingDocs" #fileUpload [customUpload]="true" [multiple]="true"
                        mode="advanced" (uploadHandler)="onUploadSupportingDocs($event)" [auto]="true" *ngIf="
              stepDetails?.is_initiator ||
              stepDetails?.is_approver ||
              stepDetails?.is_recommender ||
              (stepDetails?.step_status != 'approved' && userID == 6)
            " [maxFileSize]="209715200"
                        accept=".pdf,.doc,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                        <ng-template #empty>
                            <div>Drag and drop document here to upload.</div>
                        </ng-template>
                    </p-fileUpload> -->
                </div>
            </form>
        </ng-container>
    </div>
</div>